// Dependencies
import React from 'react';

import classnames from 'classnames';

interface PanelProps {
  className?: string;
  style?: Record<string, any>;
  children?: React.ReactNode;
}

export const Panel: React.FC<PanelProps> = (props) => {
  const { className, style, children } = props;
  const classes = classnames('panel-container', className);

  return (
    <div style={style} className={classes}>
      {children}
    </div>
  );
};

Panel.defaultProps = {
  className: null,
  style: {},
  children: null,
};

export default Panel;
